import styled, { keyframes } from "styled-components";
import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";

export const GalleryWrapper = styled(Box)`
	display: flex;
	flex-direction: column;
	align-items: center;
	.gallery-list_wrapper {
		display: flex;
		padding: 8px;
		grid-gap: 8px;
		flex-direction: column;
	}
	.add_gallery {
		width: 24px;
		height: 24px;
		padding: 2px;
		border: 2px dashed ${grey[600]};
		border-radius: 5px;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
	}
`;

export const ImageWrapper = styled.div`
	position: relative;
	width: 100%;
`;

export const StyledImg = styled.img`
	width: 100%;
	border-radius: 12px;
	transition: opacity 0.5s ease-in-out;
	display: block;
`;

const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
`;

const SkeletonBox = styled.div`
	height: 250px;
	width: 100%;
	border-radius: 12px;
	background-color: #e0e0e0;
	animation: ${pulse} 1.5s infinite ease-in-out;
`;

export const SkeletonOverlay = styled(SkeletonBox)`
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	z-index: 1;
`;
